var _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "hamburger",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: "50%",
    x2: "100%",
    y2: "50%",
    className: "hamburger__bar hamburger__bar--top"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: "50%",
    x2: "100%",
    y2: "50%",
    className: "hamburger__bar hamburger__bar--mid"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: "50%",
    x2: "100%",
    y2: "50%",
    className: "hamburger__bar hamburger__bar--bot"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.f53f4180670332d9ffe4706ada297002.svg";
export { ForwardRef as ReactComponent };